import { NgModule, isDevMode } from '@angular/core';
// import { environment } from 'src/environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JPush } from '@jiguang-ionic/jpush/ngx';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AppTranslateLoader } from '../assets/i18n';
import { SharedModule } from './shared';
import { CoreModule } from './core';
import { PipesModule } from './pipes/pipes.module';
import { Device } from '@ionic-native/device/ngx';
import { BarcodeScanner } from "@ionic-native/barcode-scanner/ngx";
// import { AppVersion } from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { IonicStorageModule } from '@ionic/storage';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Market } from '@ionic-native/market/ngx';

import { NativeService } from './providers/NativeService';
import { 
  DataService, 
  AppService, 
  LocalStorageService, 
  PopDataService, 
  HiddenDataService, 
  IncidentPopDataService,
  ImmediateFindingDataService, 
  CustomizedInspectionDataService,
  ContractorDataService,
  MenuService, 
  DocumentDataService, 
  GovDataService, 
  ExamDataService,
  SystemCodeService,
  CanActiveGuardService
} from './service';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { Camera } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { PreviewPictureComponent } from './shared/components/preview-picture/preview-picture.component';
import { JWTInterceptor } from './service/interceptor.service';
import { Toast } from '@ionic-native/toast/ngx';  
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment'; // Ensure this is imported

import { CalendarModule } from 'ion2-calendar';
@NgModule({
  declarations: [
  AppComponent,
  PreviewPictureComponent,
  ],
  entryComponents: [
  PreviewPictureComponent,
  ],
  imports: [
  BrowserModule,
  IonicModule.forRoot({
    backButtonText: '',
    // tabsHideOnSubPages: 'true',
    // iconMode: 'ios',
    animated: true,
    hardwareBackButton: true,
    swipeBackEnabled: true,
    mode: 'ios',
    // preloadModules: true
  }),
  
  AppRoutingModule,
  HttpClientModule,
  ReactiveFormsModule,
  FormsModule,
  SharedModule,
  CoreModule,
  IonicStorageModule.forRoot(),
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useClass: AppTranslateLoader
    }
  }),
  PipesModule,
  CalendarModule,
  BrowserAnimationsModule,
  ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
  StatusBar,
  SplashScreen,
  Device,
  DataService,
  AppService,
  LocalStorageService,
  PopDataService,
  HiddenDataService,
  IncidentPopDataService,
  ContractorDataService,
  ImmediateFindingDataService,
  CustomizedInspectionDataService,
  DocumentDataService,
  GovDataService,
  MenuService,
  NativeService,
  Camera,
  Diagnostic,
  ImagePicker,
  Toast,
  File,
  FileTransfer,
  InAppBrowser,
  Geolocation,
  AndroidPermissions,
  Market,
  ExamDataService,
  SystemCodeService,
  CanActiveGuardService,
  BarcodeScanner,
  { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  JPush,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JWTInterceptor,
    multi: true
  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
